export default {
    OFFSET: 'offset',
    PAGED: 'paged',
};
